var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicDecoration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 159,
    viewBox: "0 0 375 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478 132.521C278.707 82.803 209.505 211.851 -70 132.521V0H478V132.521Z",
    fill: "#880C55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1038_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 548,
    height: 159
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478 132.521C278.707 82.803 209.505 211.851 -70 132.521V0H478V132.521Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1038_474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1038_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -144,
    y: 18,
    width: 638,
    height: 160
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M493.984 150.965C262.305 101.247 181.858 230.295 -143.066 150.965V18.4438H493.984V150.965Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1038_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-143.067 105.882C88.6117 132.73 169.059 63.0443 493.983 105.882L493.983 177.444L-143.067 177.444L-143.067 105.882Z",
    fill: "black",
    fillOpacity: 0.12
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1038_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 548,
    height: 159
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M478 132.521C278.707 82.803 209.505 211.851 -70 132.521V0H478V132.521Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1038_474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1038_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -91,
    y: -55,
    width: 572,
    height: 269
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M480.718 136.206C272.507 84.4948 230.679 277.453 -63.3321 191.089L-90.9307 0.0545654L453.119 -54.8279L480.718 136.206Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1038_474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1038_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -67,
    y: 94,
    width: 573,
    height: 270
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-66.0777 172.08C142.133 223.791 183.961 30.8332 477.972 117.198L505.571 308.232L-38.4791 363.114L-66.0777 172.08Z",
    fill: "#44062B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1038_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.497 176.21C284.023 164.204 225.575 242.122 -59.2833 219.111L-71.5923 133.91L472.458 79.0276L486.497 176.21Z",
    fill: "black",
    fillOpacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicDecoration2);
export default __webpack_public_path__ + "static/media/Public_Decoration_2.9e57deec60cb4df8f53252870fe2d35d.svg";
export { ForwardRef as ReactComponent };